import { state } from './state';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

export const name = '$_student-evaluation-request-managment';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
